import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import UomService from "../../services/UomService";
import Breadcrumb from "../../components/Breadcrumb";
import StorageService from "../../services/StorageService";
import { useParams } from "react-router-dom";
import MessageDialog from "../../components/MessageDialog";


export default function AddUom() {
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false); //  added
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  // const messageTimer = useRef(null);
  const navigate = useNavigate();

  const { id } = useParams();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (id) {
      // Modify mode
      setEditMode(true);
      setEditId(id);
      fetchUomById(id);
    } else {
      // Add mode
      setValue("status", "Active");
    }
  }, [id]);

  const fetchUomById = async (uomId) => {
    setEditLoading(true); //  show spinner while fetching
    try {
      const res = await UomService.getById(uomId);

      if (res?.data) {
        const record = res.data;
        setValue("uomCode", record.uomCode || "");
        setValue("description", record.description || "");
        setValue("status", record.status || "Active");
      } else {
        showMessage("Failed to load UOM data.", "error");
      }
    } catch (error) {
      console.error(error);
      showMessage("Error fetching UOM details.", "error");
    } finally {
      setEditLoading(false); //  hide spinner after fetch
    }
  };

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      let res;

      if (editMode && editId) {
        data.updatedBy = StorageService.loginData().employeeId;
        res = await UomService.update(editId, data);
      } else {
        data.createdBy = StorageService.loginData().employeeId;
        res = await UomService.create({ ...data, status: "Active" });
      }

      console.log("Save Response:", res);

      if (res?.status || res?.id) {
        showMessage(
          editMode ? "UOM updated successfully." : "UOM added successfully.",
          "success"
        );
        setTimeout(() => {
          navigate("/cpnl/uom/view");
        }, 1000);
      } else if (
        res?.message &&
        res.message.toLowerCase().includes("duplicate")
      ) {
        showMessage("Duplicate UOM Name or Code!", "error");
      } else {
        showMessage("Failed to save UOM.", "error");
      }
    } catch (error) {
      console.error("Error saving UOM:", error);
      const msg =
        error.response?.data?.message || error.message || "Error saving UOM";

      if (msg.toLowerCase().includes("duplicate")) {
        showMessage("Duplicate UOM Name or Code!", "error");
      } else {
        showMessage(msg, "error");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/cpnl/uom/view");
  };

  return (
    <>
      <Breadcrumb
        pageTitle={editMode ? "Modify UOM" : "Add UOM"}
        secondTitle="Masters"
      ></Breadcrumb>

      {/* {message && (
        <div
          className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
            } d-flex justify-content-between align-items-center mb-2 p-2`}
          style={{ borderRadius: "5px" }}
        >
          <span>{message}</span>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeMessage}
          ></button>
        </div>
      )} */}

    
        <MessageDialog
          message={message}
          type={msgType}
          setMessage={setMessage}
          setMsgType={setMsgType}
        />
      

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">
          {editLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary"></div>
              <div className="mt-2 text-muted">Loading data...</div>
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">
                    UOM Code <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.uomCode ? "is-invalid" : ""}`}
                    {...register("uomCode", { required: "UOM Code is required" })}
                    onInput={(e) => {
                      e.target.value = e.target.value.toUpperCase();
                    }}
                    disabled={loading}
                  />
                  {errors.uomCode && (
                    <small className="text-danger">{errors.uomCode.message}</small>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    UOM Description
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.description ? "is-invalid" : ""}`}
                    {...register("description")}
                    disabled={loading}
                  />

                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className="btn btn-primary me-2"
                  disabled={loading}
                >
                  <i className="ti ti-circle-check me-1"></i>
                  {loading
                    ? editMode
                      ? "Updating..."
                      : "Saving..."
                    : editMode
                      ? "Update"
                      : "Save"}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCancel}
                  disabled={loading}
                >
                  <i className="ti ti-cancel me-1"></i>
                  Cancel
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
